const FaqEdit = () => {
	return (
		<div>
		</div>
	);
};

export default FaqEdit;
